import React from 'react';

const AppIcon = ({ className = "h-12 w-12" }) => {
  return (
    <div className={`relative ${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" className="fill-current text-blue-500 dark:text-blue-400" />
        <circle cx="32" cy="32" r="20" className="fill-current text-gray-800 dark:text-gray-200 opacity-30" />
        <circle cx="32" cy="32" r="12" className="stroke-current text-white dark:text-gray-100 opacity-70" strokeWidth="2" />
        <circle cx="24" cy="24" r="4" className="fill-current text-white dark:text-gray-100" />
      </svg>
      
      {/* Animated glow effect */}
      <div className="absolute inset-0 rounded-full bg-blue-500 dark:bg-blue-400 opacity-30 blur-md animate-pulse-slow"></div>
    </div>
  );
};

export default AppIcon;